var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"right":"","split":"","alt":"View Location","title":"View Location","split-to":{ name: 'LocationDetails', params: { id: _vm.locationId } }}},[_c('template',{slot:"button-content"},[_c('font-awesome-icon',{attrs:{"icon":"eye"}}),_vm._v(" View")],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'LocationTrends', params: { id: _vm.locationId } }}},[_c('i',{staticClass:"fa fa-chart-line mr-1 mr-lg-2"}),_vm._v(" Trends")]),_vm._v(" "),(
      _vm.projectId &&
      _vm.membershipMap[_vm.projectId] &&
      _vm.membershipMap[_vm.projectId].isManager
    )?_c('b-dropdown-divider'):_vm._e(),_vm._v(" "),(
      _vm.projectId &&
      _vm.membershipMap[_vm.projectId] &&
      _vm.membershipMap[_vm.projectId].isManager
    )?_c('b-dropdown-item',{attrs:{"to":{ name: 'LocationAssignments', params: { id: _vm.locationId } }}},[_c('i',{staticClass:"fa fa-thumb-tack mr-1 mr-lg-2"}),_vm._v("Assignments")]):_vm._e(),_vm._v(" "),(
      _vm.projectId &&
      _vm.membershipMap[_vm.projectId] &&
      _vm.membershipMap[_vm.projectId].isManager
    )?_c('b-dropdown-item',{attrs:{"to":{ name: 'LocationEdit', params: { id: _vm.locationId } }}},[_c('i',{staticClass:"fa fa-edit mr-1 mr-lg-2"}),_vm._v("Edit")]):_vm._e(),_vm._v(" "),(
      _vm.projectId &&
      _vm.membershipMap[_vm.projectId] &&
      _vm.membershipMap[_vm.projectId].isManager
    )?_c('b-dropdown-divider'):_vm._e(),_vm._v(" "),(
      _vm.projectId &&
      _vm.membershipMap[_vm.projectId] &&
      _vm.membershipMap[_vm.projectId].isManager
    )?_c('b-dropdown-item',{attrs:{"to":{ name: 'LocationDelete', params: { id: _vm.locationId } }}},[_c('i',{staticClass:"fa fa-trash mr-1 mr-lg-2"}),_vm._v("Delete")]):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }